import { Heart } from "lucide-react";
import { useState } from "react";
import { useAuth } from "../lib/auth";

export default function PhotoTile({ photo, onOpen }) {
  const [loaded, setLoaded] = useState(false);
  const { isFavorited, toggleFavorite } = useAuth();
  const aspect = photo.width && photo.height ? photo.width / photo.height : 1;
  const faved = isFavorited(photo.id);

  return (
    <button
      type="button"
      onClick={() => onOpen(photo)}
      data-testid={`photo-tile-${photo.id}`}
      className="relative w-full block group overflow-hidden bg-secondary text-left"
      style={{
        aspectRatio: `${aspect}`,
        backgroundColor: photo.avg_color || "#e9e5dd",
      }}
    >
      {!loaded && <div className="absolute inset-0 es-shimmer" />}
      <img
        src={photo.src?.medium || photo.src?.small}
        alt={photo.alt || `Photo by ${photo.photographer?.name || "unknown"}`}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        className={`absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04] ${
          loaded ? "es-fade-in" : "opacity-0"
        }`}
        data-testid={`photo-tile-img-${photo.id}`}
      />

      {/* Persistent heart when favorited */}
      {faved && (
        <span
          role="button"
          onClick={(e) => { e.stopPropagation(); toggleFavorite(photo); }}
          data-testid={`photo-tile-heart-active-${photo.id}`}
          className="absolute top-2 right-2 inline-flex items-center justify-center h-7 w-7 rounded-full bg-gold text-ivory shadow"
          title="Remove from favorites"
        >
          <Heart className="h-3.5 w-3.5 fill-current" />
        </span>
      )}

      {/* hover overlay */}
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gradient-to-t from-ink/85 via-ink/25 to-transparent pointer-events-none" />
      <div className="absolute inset-x-0 bottom-0 p-2 md:p-2.5 flex items-end justify-between gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        <div className="text-ivory min-w-0 hidden sm:block">
          <div className="text-[9px] uppercase tracking-[0.2em] text-ivory/60 leading-tight">Photographer</div>
          <div className="font-serif text-xs md:text-sm leading-tight truncate">
            {photo.photographer?.name || "Unknown"}
          </div>
        </div>
        <span
          role="button"
          onClick={(e) => { e.stopPropagation(); toggleFavorite(photo); }}
          data-testid={`photo-tile-heart-${photo.id}`}
          className={`pointer-events-auto inline-flex items-center justify-center h-7 w-7 rounded-full transition-colors shrink-0 ml-auto ${
            faved ? "bg-gold text-ivory" : "bg-ivory/95 text-ink hover:bg-gold hover:text-ivory"
          }`}
          title={faved ? "Remove from favorites" : "Save to favorites"}
        >
          <Heart className={`h-3.5 w-3.5 ${faved ? "fill-current" : ""}`} />
        </span>
      </div>
    </button>
  );
}
